// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.ticket-card {
  display: flex;
  min-height: 120px;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: rgba(var(--gc-color-light-rgb), 0.5);
  border: 1px solid rgba(var(--gc-color-medium-rgb), 0.6);
  box-shadow: var(--gc-box-shadow);
  position: relative;
  cursor: pointer;
}
.ticket-card:hover {
  background-color: rgba(var(--gc-color-light-rgb), 0.9);
  border-color: rgba(var(--gc-color-medium-rgb), 1);
}
.ticket-card.is-hidden {
  background-color: rgba(var(--gc-color-warning-rgb), 0.1);
  border-color: rgba(var(--gc-color-warning-rgb), 7);
}
.ticket-card.is-hidden:hover {
  background-color: rgba(var(--gc-color-warning-rgb), 0.3);
}
.ticket-card.medium-prio {
  background-color: rgba(var(--gc-color-medium-rgb), 0.5);
  border: 1px solid rgba(var(--gc-color-medium-rgb), 0.7);
}
.ticket-card.medium-prio:hover {
  background-color: rgba(var(--gc-color-medium-rgb), 0.5);
  border-color: rgba(var(--gc-color-medium-rgb), 0.9);
}
.ticket-card.high-prio {
  background-color: rgba(var(--gc-color-danger-rgb), 0.4);
  border: 1px solid rgba(var(--gc-color-danger-rgb), 0.7);
}
.ticket-card.high-prio:hover {
  background-color: rgba(var(--gc-color-danger-rgb), 0.5);
}
.ticket-card.is-done {
  border: 1px solid rgba(var(--gc-color-medium-rgb), 0.6);
  background: repeating-linear-gradient(45deg, rgba(var(--gc-color-medium-rgb), 0.15), rgba(var(--gc-color-medium-rgb), 0.15) 15px, rgba(var(--gc-color-medium-rgb), 0.25) 15px, rgba(var(--gc-color-medium-rgb), 0.25) 30px);
  color: rgba(var(--gc-text-color-rgb), 0.6);
  display: block !important;
}
.ticket-card.is-done:hover {
  background-color: rgba(var(--gc-color-medium-rgb), 0.2);
}
.ticket-card .badge {
  height: 16px;
  width: 16px;
  background-color: var(--gc-color-danger);
  border-radius: 50%;
  position: absolute;
  top: -8px;
  right: -8px;
  overflow: visible;
}
.ticket-card .status {
  position: absolute;
  top: 0.15rem;
  right: 0.25rem;
}
.ticket-card .card-title {
  font-weight: bold;
}
.ticket-card .card-content {
  display: block;
}
.ticket-card .card-footer {
  display: block;
}
.ticket-card .final-state .text {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  font-size: 2rem;
  color: rgba(var(--gc-text-color-rgb), 0.15);
  font-weight: bold;
  rotate: -20eg;
}
.ticket-card .final-state .icon {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 1rem;
  font-size: 80px;
  opacity: 0.3;
}

v-icon.large {
  font-size: 3rem;
}

.custom-icon {
  height: 1.2rem;
  width: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ngx-workflow/components/tickets/overview-item/overview-item.component.sass"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;AACJ;;AAAA;EACQ,aAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,sDAAA;EACA,uDAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;AAGR;AAFQ;EACI,sDAAA;EACA,iDAAA;AAIZ;AAHQ;EACI,wDAAA;EACA,kDAAA;AAKZ;AAJY;EACI,wDAAA;AAMhB;AALQ;EACI,uDAAA;EACA,uDAAA;AAOZ;AANY;EACI,uDAAA;EACA,mDAAA;AAQhB;AAPQ;EACI,uDAAA;EACA,uDAAA;AASZ;AARY;EACI,uDAAA;AAUhB;AATQ;EACI,uDAAA;EACA,2NAAA;EACA,0CAAA;EACA,yBAAA;AAWZ;AAVY;EACI,uDAAA;AAYhB;AAXQ;EACI,YAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AAaZ;AAZQ;EACI,kBAAA;EACA,YAAA;EACA,cAAA;AAcZ;AAZQ;EACI,iBAAA;AAcZ;AAbQ;EACI,cAAA;AAeZ;AAdQ;EACI,cAAA;AAgBZ;AAdY;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EAIA,eAAA;EACA,2CAAA;EACA,iBAAA;EACA,aAAA;AAahB;AAZY;EACI,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAchB;;AAXI;EACI,eAAA;AAcR;;AAZA;EACI,cAAA;EACA,aAAA;AAeJ","sourcesContent":[":host\n    display: block\n    height: 100%\n.ticket-card\n        display: flex\n        min-height: 120px\n        width: 100%\n        flex-direction: column\n        justify-content: space-between\n        padding: 0.5rem\n        background-color: rgba(var(--gc-color-light-rgb), 0.5)\n        border: 1px solid rgba(var(--gc-color-medium-rgb), 0.6)\n        box-shadow: var(--gc-box-shadow)\n        position: relative\n        cursor: pointer\n        &:hover\n            background-color: rgba(var(--gc-color-light-rgb), 0.9)\n            border-color: rgba(var(--gc-color-medium-rgb), 1)\n        &.is-hidden\n            background-color: (rgba(var(--gc-color-warning-rgb), 0.1))\n            border-color: rgba(var(--gc-color-warning-rgb), 7)\n            &:hover\n                background-color: (rgba(var(--gc-color-warning-rgb), 0.3))\n        &.medium-prio\n            background-color: rgba(var(--gc-color-medium-rgb), 0.5)\n            border: 1px solid rgba(var(--gc-color-medium-rgb), 0.7)\n            &:hover\n                background-color: rgba(var(--gc-color-medium-rgb), 0.5)\n                border-color: rgba(var(--gc-color-medium-rgb), 0.9)\n        &.high-prio\n            background-color: rgba(var(--gc-color-danger-rgb), 0.4)\n            border: 1px solid rgba(var(--gc-color-danger-rgb), 0.7)\n            &:hover\n                background-color: rgba(var(--gc-color-danger-rgb), 0.5)\n        &.is-done\n            border: 1px solid rgba(var(--gc-color-medium-rgb), 0.6)\n            background: repeating-linear-gradient(45deg, rgba(var(--gc-color-medium-rgb), 0.15), rgba(var(--gc-color-medium-rgb), 0.15) 15px, rgba(var(--gc-color-medium-rgb), 0.25) 15px, rgba(var(--gc-color-medium-rgb), 0.25) 30px)\n            color: rgba(var(--gc-text-color-rgb), 0.6)\n            display: block !important\n            &:hover\n                background-color: rgba(var(--gc-color-medium-rgb), 0.2)\n        .badge\n            height: 16px\n            width: 16px\n            background-color: var(--gc-color-danger)\n            border-radius: 50%\n            position: absolute\n            top: -8px\n            right: -8px\n            overflow: visible\n        .status\n            position: absolute\n            top: 0.15rem\n            right: 0.25rem\n        //.card-header\n        .card-title\n            font-weight: bold\n        .card-content\n            display: block\n        .card-footer\n            display: block\n        .final-state\n            .text\n                position: absolute\n                bottom: 0.5rem\n                left: 0.5rem\n                // top: 50%\n                // left: 10%\n                // transform: translate(-10%, -50%)\n                font-size: 2rem\n                color: rgba(var(--gc-text-color-rgb), 0.15)\n                font-weight: bold\n                rotate: -20eg\n            .icon\n                position: absolute\n                top: 50%\n                transform: translate(0, -50%)\n                right: 1rem\n                font-size: 80px\n                opacity: 0.3\n\nv-icon\n    &.large\n        font-size: 3rem\n\n.custom-icon\n    height: 1.2rem\n    width: 1.2rem\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
